import { SecondaryButton } from '@changegps/horizon-component-library';
import { Stack, Typography } from '@mui/material';
import { useFormContext } from 'react-hook-form';

import { ControlledInputs } from '@/components';

import { productTag } from '../data';
import { PlanForm, SubscriptionForm } from '../hooks';

import { SummaryBox, SummaryBoxTitle } from './Filters.components';
import { ProductRow } from './ProductRow';

export type ProductSummaryProps = {
  action: () => void;
  toggleDrawer: () => void;
};

export const ProductSummary = (props: ProductSummaryProps) => {
  const { control, watch } = useFormContext<SubscriptionForm>();

  const data = watch();
  const keys = Object.keys(watch()).filter(
    (item) => item !== 'coupon',
  ) as Array<keyof SubscriptionForm>;

  return (
    <Stack gap={1}>
      <Typography fontSize={36} fontWeight={100}>
        Product Summary
      </Typography>
      <SummaryBox>
        <SummaryBoxTitle>
          Items in your cart
          <Stack direction="row" gap={0.5}>
            <Typography fontWeight={700}>(4)</Typography>
            <Typography>items</Typography>
          </Stack>
        </SummaryBoxTitle>

        {keys.map((item, key) => {
          const productData = data[item];

          if (
            productData &&
            typeof productData === 'object' &&
            productData !== null
          ) {
            return (
              <ProductRow
                tag={productTag[key]}
                product={item}
                {...(productData as PlanForm)}
                key={item}
              />
            );
          }
          return null;
        })}

        <Stack
          direction="row"
          padding="15px 20px 20px"
          justifyContent="space-between"
        >
          <SecondaryButton onClick={props.action}>
            Change Product Selection
          </SecondaryButton>
          <ControlledInputs.TextField
            ControllerProps={{
              control: control,
              name: 'coupon',
            }}
            placeholder="Enter Coupon Code"
          />
        </Stack>
      </SummaryBox>
    </Stack>
  );
};
